import WrappedNormalLoginForm from 'containers/Security/WrappedLoginForm';
import PublicLayout           from 'containers/Security/PublicLayout';

const Login = () => (
  <PublicLayout>
    <WrappedNormalLoginForm />
  </PublicLayout>
);

export default Login;
